import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        cancelButton: {
            alignSelf: 'center',
        },
    }
})

export default useStyles
